module.exports = __webpack_public_path__ + "static/media/linkedin.f253de3a.svg";